module.exports = [{
      plugin: require('/Users/kyleeverettlang/Documents/coding/portfolio/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
